import React, { useState, useContext } from 'react';
import { Row, Col, Container } from 'reactstrap';
import classNames from "classnames";
import styles from './GetStarted.module.css';
import { SessionContext } from '../../context/SessionContext';
import ProtectionBannerNordyne from '../../assets/images/Vendor/Nordyne/AdobeStock_516584127.jpeg';
import PeopleBannerNordyne from '../../assets/images/Vendor/Nordyne/AdobeStock_917244266.jpeg';
import PeopleDiscussionNordyne from '../../assets/images/Vendor/Nordyne/AdobeStock_437886230.jpeg';
import EnrollmentModal from '../../components/Modals/Enrollment/Enrollment';
import { ReactComponent as ShieldCheck } from '../../assets/images/Vendor/Nordyne/shield-check-Nordyne.svg';
import { ReactComponent as CheckMark } from '../../assets/images/checkmark.svg';
import { ReactComponent as QuestionNordyne } from '../../assets/images/Vendor/Nordyne/questions-Nordyne.svg';

const GetStarted = () => {
    const sessionContext = useContext(SessionContext);
    const { accountName } = sessionContext;
    const [showEnrollmentModal, setShowEnrollmentModal] = useState(false);

    const handleShowActionModal = () => {
        setShowEnrollmentModal(true);
    };

    return (
        <>
            <Row className={styles.businessGrowthContainer}> 
                <Col md="12" lg="6" className={styles.growthImageContainer}>
                    <img 
                        src={ProtectionBannerNordyne}
                        alt='protectionbanner' 
                    />
                </Col>
                <Col md="12" lg="6" className={styles.growthDescriptionContainer}>
                    <h1 className={styles.getStartedHeader}>HOW CAN WE HELP <br/>GROW YOUR BUSINESS?</h1>
                    <hr />
                    <p>
                        Revenue from extended service agreements 
                        helps <span>build your business</span> outside the dependence on frequency of individual
                        installations or service calls.
                    </p>
                    <p>
                        Extended service agreements are a great way to 
                        help <span>protect your customers' budgets</span> while also 
                        getting their equipment professionally serviced by you.
                        These positive experiences drive trust, relationships and recommendations.
                    </p>
                    <button
                        className={styles.enrollToday}
                        onClick={(e) => handleShowActionModal()}
                    >
                        Enroll Today
                    </button>
                </Col>
            </Row>
            <Row className={styles.businessGrowthContainer}> 
                <Col 
                    xs={{size: 12, order: 2}} 
                    sm={{size: 12, order: 2}} 
                    md={{size: 12, order: 2}} 
                    lg={{size: 6, order: 1}} 
                    className={styles.growthDescriptionContainer}
                >
                    <h1 className={styles.getStartedHeader}>FLEXIBLE PLAN OPTIONS WITH YOU IN MIND</h1>
                    <hr />
                    <ul>
                        <li>
                            <CheckMark />
                            Competitive labor reimbursement rate options
                        </li>
                        <li>
                            <CheckMark />
                            Labor Only or Parts and Labor coverage available
                        </li>
                        <li>
                            <CheckMark />
                            Extended service agreement terms up to 10 years
                        </li>
                        <li>
                            <CheckMark />
                            Online portal for easy sales and claims submission
                        </li>
                    </ul>
                </Col>
                <Col 
                    xs={{size: 12, order: 1}} 
                    sm={{size: 12, order: 1}} 
                    md={{size: 12, order: 1}} 
                    lg={{size: 6, order: 2}} 
                    className={styles.growthImageContainer}
                >
                    <img 
                        src={PeopleBannerNordyne}
                        alt='people banner Nordyne'
                    />
                </Col>
            </Row>
            <Row className={styles.callCenterBannerContainer}>
                <Row className={styles.callCenterBannerInner}>
                    <QuestionNordyne/>
                    <h2>
                        According to the call center statistics, one of the 
                        top questions asked by consumers is for clarification
                        of their warranty coverage.
                    </h2>
                </Row>
            </Row>
             <Row className={styles.copyRightContainer}>
                <p className='m-0'>
                    Nordyne Extended Labor Program plans are sold by Nordyne.
                    Plans are issued and administered by AIG WarrantyGuard Inc., part of AIG, one or more of its
                    affiliates. Plans are subject to detailed terms, conditions and limitations. For further information,
                    please review the full plan terms and conditions. Nordyne is not affiliated with AIG or any of its affiliates.
                    Trademark used with permission.
                </p>
            </Row>
            {showEnrollmentModal && (
                <EnrollmentModal
                    isOpen={showEnrollmentModal}
                    centered={true}
                    toggle={() => setShowEnrollmentModal(!showEnrollmentModal)}
                    accountName={accountName}
                />
            )}
        </>
    );
}

export default GetStarted;